import React from 'react';
import './Energy.css';

const Healthcare = () => {
  return (
    <div className="Energy-wrapper">
      <div className="Energy-content">
        <h2>Énergie</h2>
        <p>Nous intervenons dans la modernisation et la maintenance des systèmes électriques pour les installations énergétiques, en assurant performance, sécurité et conformité aux normes.</p>
      </div>
    </div>
  );
};

export default Healthcare;